export default __webpack_public_path__ + "static/media/Grey_3.8e590998.svg";